import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back, Tanuj");
      navigate("/", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-stretch bg-aot-bg text-aot-text">
      {/* Left — brand panel */}
      <div className="hidden lg:flex flex-col justify-between w-[55%] p-12 border-r border-aot-border relative aot-noise">
        <div className="aot-grid-bg absolute inset-0 opacity-40" />
        <div className="relative z-10 flex items-center gap-3">
          <div className="w-2.5 h-2.5 bg-aot-teal" />
          <span className="text-xs font-mono tracking-[0.25em] text-aot-muted uppercase">
            Agents of Tanuj
          </span>
        </div>

        <div className="relative z-10 max-w-xl">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-aot-teal mb-6">
            // Command Centre
          </p>
          <h1 className="font-display text-5xl xl:text-6xl font-bold leading-[1.02] tracking-tight">
            Autonomous agents.
            <br />
            <span className="text-aot-muted">One operator.</span>
          </h1>
          <p className="mt-8 text-aot-muted text-sm leading-relaxed max-w-md">
            This is not a CRM with a chatbot bolted on. Claude is the agent — it searches, thinks,
            scores, and writes. You review, you decide, you close.
          </p>

          <div className="mt-12 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-aot-subtle">
            <span className="w-8 h-px bg-aot-border" />
            <span>Projects · Fundraising · anything you run</span>
          </div>
        </div>

        <div className="relative z-10 flex items-center justify-between text-[11px] font-mono text-aot-subtle uppercase tracking-widest">
          <span>powered by claude · sonnet 4.6</span>
          <span>SGP · 01°17'N</span>
        </div>
      </div>

      {/* Right — form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-sm" data-testid="login-form">
          <div className="mb-10">
            <p className="text-xs font-mono uppercase tracking-[0.3em] text-aot-muted mb-3">
              Restricted Access
            </p>
            <h2 className="font-display text-3xl font-semibold tracking-tight">Sign in</h2>
            <p className="mt-2 text-sm text-aot-muted">
              Single-user console. Enter your credentials to continue.
            </p>
          </div>

          <label className="block mb-5">
            <span className="block text-[10px] font-mono uppercase tracking-[0.25em] text-aot-muted mb-2">
              Email
            </span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              autoComplete="username"
              className="w-full bg-transparent border-b border-aot-border focus:border-aot-teal focus:outline-none py-2 text-aot-text placeholder:text-aot-subtle transition-colors"
              placeholder="you@domain.com"
            />
          </label>

          <label className="block mb-8">
            <span className="block text-[10px] font-mono uppercase tracking-[0.25em] text-aot-muted mb-2">
              Password
            </span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              autoComplete="current-password"
              className="w-full bg-transparent border-b border-aot-border focus:border-aot-teal focus:outline-none py-2 text-aot-text placeholder:text-aot-subtle transition-colors"
              placeholder="••••••••"
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-aot-teal text-aot-bg font-medium py-3 hover:bg-aot-teal/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <span className="inline-block w-3 h-3 border-2 border-aot-bg border-t-transparent rounded-full animate-spin" />
                <span className="font-mono tracking-wider text-xs uppercase">Authenticating</span>
              </>
            ) : (
              <span className="font-mono tracking-wider text-xs uppercase">Enter Console →</span>
            )}
          </button>

          <p className="mt-8 text-[10px] font-mono uppercase tracking-[0.25em] text-aot-subtle text-center">
            agentsoftanuj.com · v0.1
          </p>
        </form>
      </div>
    </div>
  );
}
